import {
  CityDestinationWithLeagues,
  SportsDestinationSection,
} from '@v2/types';
import { create } from 'zustand';

interface WhiteLabelDestinationStore {
  sportsDestination: SportsDestinationSection[];
  setSportsDestination: (sections?: SportsDestinationSection[] | null) => void;
  getCityBySlug: (slug: string) => CityDestinationWithLeagues | undefined;
  reset: () => void;
}

const normalizeSlug = (slug: string) => {
  if (!slug) return '';

  let decoded = slug;

  try {
    decoded = decodeURIComponent(slug);
  } catch (error) {
    decoded = slug;
  }

  return decoded.trim().toLowerCase().replace(/\s+/g, '-').replace(/-+/g, '-');
};

export const useWhiteLabelDestinationStore = create<WhiteLabelDestinationStore>(
  (set, get) => ({
    sportsDestination: [],
    setSportsDestination: (sections) =>
      set({ sportsDestination: sections ? [...sections] : [] }),
    getCityBySlug: (slug) => {
      const normalizedSlug = normalizeSlug(slug);

      for (const section of get().sportsDestination) {
        const match = section.cities.find(
          (city) => normalizeSlug(city.citySlug) === normalizedSlug
        );

        if (match) {
          return match;
        }
      }

      return undefined;
    },
    reset: () => set({ sportsDestination: [] }),
  })
);
